import { Component } from '@angular/core';

@Component({
  selector: 'app-stats-section',
  imports: [],
  templateUrl: './stats-section.component.html',
  styleUrl: './stats-section.component.css',
})
export class StatsSectionComponent {

}
